import request from '@/utils/request'

export default {
  fetchProducerList(data) {
    return request({
      url: `/producer/list`,
      method: 'post',
      data
    })
  },
  fetchProducerCodeList(data) {
    return request({
      url: `/producer/listAllCode`,
      method: 'post',
      data
    })
  },
  createProducer(data) {
    return request({
      url: '/producer/add',
      method: 'post',
      data
    })
  },
  editProducer(data) {
    return request({
      url: `/producer/edit`,
      method: 'POST',
      data
    })
  },
  // 更新生产商状态
  updateProducerStatus(data) {
    return request({
      url: `/producer/updateStatus`,
      method: 'POST',
      data
    })
  }
}
